import { render, staticRenderFns } from "./Transitions.vue?vue&type=template&id=0870d357&"
import script from "./Transitions.vue?vue&type=script&lang=js&"
export * from "./Transitions.vue?vue&type=script&lang=js&"
import style0 from "./Transitions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports